module.exports = __webpack_public_path__ + "static/gallery8-7bff6c3a4dcaf3ce11bd7f8908cb5215.jpg";